"use strict";
exports.__esModule = true;
exports.DisplayStatus = exports.PaymentMethodTypeV2 = exports.TransactionStatusV2 = exports.TransactionTypeV2 = exports.LineItemType = exports.PaymentAvailableAction = exports.PaymentStatusV2 = exports.PaymentCategoryV2 = exports.ReinforcementMessage = exports.PaymentDays = exports.PaymentRetryWindow = exports.PaymentRetryWindowLabel = void 0;
var PaymentRetryWindowLabel;
(function (PaymentRetryWindowLabel) {
    PaymentRetryWindowLabel["TWELVE_TO_FOURTEEN_HOURS"] = "12-14 hours";
    PaymentRetryWindowLabel["TWENTY_FOUR_TO_TWENTY_SIX_HOURS"] = "24-26 hours";
})(PaymentRetryWindowLabel = exports.PaymentRetryWindowLabel || (exports.PaymentRetryWindowLabel = {}));
var PaymentRetryWindow;
(function (PaymentRetryWindow) {
    PaymentRetryWindow["TWELVE_TO_FOURTEEN_HOURS"] = "12_TO_14_HOURS";
    PaymentRetryWindow["TWENTY_FOUR_TO_TWENTY_SIX_HOURS"] = "24_TO_26_HOURS";
})(PaymentRetryWindow = exports.PaymentRetryWindow || (exports.PaymentRetryWindow = {}));
var PaymentDays;
(function (PaymentDays) {
    PaymentDays["FIRST_DAY"] = "firstDay";
    PaymentDays["SECOND_DAY"] = "secondDay";
})(PaymentDays = exports.PaymentDays || (exports.PaymentDays = {}));
var ReinforcementMessage;
(function (ReinforcementMessage) {
    ReinforcementMessage["FIRST_NEGATIVE"] = "firstNegative";
    ReinforcementMessage["FIRST_POSITIVE"] = "firstPositive";
    ReinforcementMessage["SECOND_NEGATIVE"] = "secondNegative";
    ReinforcementMessage["SECOND_POSITIVE"] = "secondPositive";
})(ReinforcementMessage = exports.ReinforcementMessage || (exports.ReinforcementMessage = {}));
// Enums
var PaymentCategoryV2;
(function (PaymentCategoryV2) {
    PaymentCategoryV2["DEPOSIT"] = "DEPOSIT";
    PaymentCategoryV2["DOWN_PAYMENT"] = "DOWN_PAYMENT";
    PaymentCategoryV2["REPAYMENT"] = "REPAYMENT";
    PaymentCategoryV2["MMF"] = "MMF";
    PaymentCategoryV2["RENT_PAYMENT"] = "RENT_PAYMENT";
    PaymentCategoryV2["ADDITIONAL_DEPOSIT"] = "ADDITIONAL_DEPOSIT";
})(PaymentCategoryV2 = exports.PaymentCategoryV2 || (exports.PaymentCategoryV2 = {}));
var PaymentStatusV2;
(function (PaymentStatusV2) {
    PaymentStatusV2["SCHEDULED"] = "SCHEDULED";
    PaymentStatusV2["PENDING"] = "PENDING";
    PaymentStatusV2["COMPLETE"] = "COMPLETE";
    PaymentStatusV2["ACTION_NEEDED"] = "ACTION_NEEDED";
})(PaymentStatusV2 = exports.PaymentStatusV2 || (exports.PaymentStatusV2 = {}));
var PaymentAvailableAction;
(function (PaymentAvailableAction) {
    PaymentAvailableAction["PAY_NOW"] = "PAY_NOW";
    PaymentAvailableAction["PRE_PAY"] = "PRE_PAY";
    PaymentAvailableAction["RESCHEDULE"] = "RESCHEDULE";
})(PaymentAvailableAction = exports.PaymentAvailableAction || (exports.PaymentAvailableAction = {}));
var LineItemType;
(function (LineItemType) {
    LineItemType["BASE"] = "BASE";
    LineItemType["FINANCE_CHARGE"] = "FINANCE_CHARGE";
    LineItemType["PROCESSING_FEE"] = "PROCESSING_FEE";
    LineItemType["PROPERTY_PASSTHROUGH_FEE"] = "PROPERTY_PASSTHROUGH_FEE";
})(LineItemType = exports.LineItemType || (exports.LineItemType = {}));
var TransactionTypeV2;
(function (TransactionTypeV2) {
    TransactionTypeV2["PAYMENT"] = "PAYMENT";
    TransactionTypeV2["REFUND"] = "REFUND";
})(TransactionTypeV2 = exports.TransactionTypeV2 || (exports.TransactionTypeV2 = {}));
var TransactionStatusV2;
(function (TransactionStatusV2) {
    TransactionStatusV2["PENDING"] = "PENDING";
    TransactionStatusV2["SUCCESS"] = "SUCCESS";
    TransactionStatusV2["FAILURE"] = "FAILURE";
})(TransactionStatusV2 = exports.TransactionStatusV2 || (exports.TransactionStatusV2 = {}));
var PaymentMethodTypeV2;
(function (PaymentMethodTypeV2) {
    PaymentMethodTypeV2["CARD"] = "CARD";
    PaymentMethodTypeV2["FUNDS"] = "FUNDS";
})(PaymentMethodTypeV2 = exports.PaymentMethodTypeV2 || (exports.PaymentMethodTypeV2 = {}));
var DisplayStatus;
(function (DisplayStatus) {
    DisplayStatus["PENDING"] = "PENDING";
    DisplayStatus["COMPLETE"] = "COMPLETE";
    DisplayStatus["FAILURE"] = "FAILURE";
    DisplayStatus["SCHEDULED"] = "SCHEDULED";
    DisplayStatus["REFUND"] = "REFUND";
    DisplayStatus["FUNDED"] = "FUNDED";
    DisplayStatus["UNPAID"] = "UNPAID";
    DisplayStatus["ACTION_NEEDED"] = "ACTION_NEEDED";
})(DisplayStatus = exports.DisplayStatus || (exports.DisplayStatus = {}));
